<template lang="pug">
  .menu-list(v-show="showMenu")
    a.container(:href="portalUrl" target='_blank')
      v-icon home
      p Home
    a.container(:href="portalUrl + '/support'" target='_blank')
      v-icon help
      p Support
    a.container(:href="portalUrl + '/contact'" target='_blank')
      v-icon mail
      p Contact
</template>

<script>
export default {
  data: () => ({
  }),
  computed: {
    showMenu () {
      return this.$store.state.menuVisible
    },
    portalUrl () {
      return (process.env.VUE_APP_PORTAL_URL) ? process.env.VUE_APP_PORTAL_URL : 'https://stg.coloradoforestatlas.org'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .menu-list
    transition all .3s cubic-bezier(0.55, 0, 0.1, 1)
    position fixed
    right 10px
    top 54px
    z-index 10
    box-shadow 0 4px 6px rgba(0,0,0,0.26)
    width 150px
    border-radius 2px
    background-color #fff
    color black
    box-sizing border-box
  .container
    padding 1em 0 0 2em
    font-weight bolder
    display -webkit-box
    text-decoration none
    &:hover
      background-color rgba(0,0,0,0.26)
      color white
    & p
      margin-left 11px
</style>
